import { PropsWithChildren } from 'react';
import type { Interpolation, Theme } from '@emotion/react';
import { css } from '@linaria/atomic';
import { cx } from '@linaria/atomic';
import { motion, HTMLMotionProps } from 'motion/react';

export interface SlideContainerProps extends PropsWithChildren<HTMLMotionProps<'div'>> {
  css?: Interpolation<Theme>;
}

export const SlideContainer = ({ children, className, ...rest }: SlideContainerProps) => {
  return (
    <motion.div {...rest} className={cx(containerStyle, className)}>
      {children}
    </motion.div>
  );
};

const containerStyle = css`
  display: flex;
  height: 100%;
  overflow-x: hidden;
  position: relative;
  transition: transform 0.5s ease;
`;
